export default "__VITE_ASSET__DFtFaGR0__"